import { render, staticRenderFns } from "./ed-select-tag.component.vue?vue&type=template&id=1a91b26d&scoped=true&"
import script from "./ed-select-tag.component.ts?vue&type=script&lang=ts&"
export * from "./ed-select-tag.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-select-tag.component.scss?vue&type=style&index=0&id=1a91b26d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91b26d",
  null
  
)

export default component.exports